import { getScheduleVisitQueryParams, LinkType } from 'common-src/models/PatientOncehubBooking';

import useOpenWindow from 'src/hooks/useOpenWindow';

const usePatientTaskLink = (task, patient, primaryPatientPhoneNumber) => {
  const { openWindow } = useOpenWindow();

  const linkHandler = () => {
    if (!task.link) return;

    const params = task.link.includes(LinkType.Oncehub.toLowerCase())
      ? getScheduleVisitQueryParams(patient, primaryPatientPhoneNumber, LinkType.Oncehub)
      : '';

    openWindow({ url: `${task.link}${params}`, target: '_blank' });
  };

  return { linkHandler };
};

export default usePatientTaskLink;
